import request from 'utils/request';
import { keysToSnakeCase, keysToSnakeCaseDeep } from 'utils/stringUtils';

export default {
  get: async (customInterrogationId) => {
    const customInterrogation = await request.get(
      `/suppliers/custom_interrogators/${customInterrogationId}`,
    );
    return {
      ...customInterrogation,
      taskInputs: keysToSnakeCaseDeep(customInterrogation.taskInputs),
    };
  },

  list: async (groupId) => {
    return await request.get(`/suppliers/${groupId}/custom_interrogators`);
  },

  create: async (groupId, data) => {
    return await request.post(
      `/suppliers/${groupId}/custom_interrogators`,
      keysToSnakeCase(data),
    );
  },

  update: async (customInterrogationId, data) => {
    const customInterrogation = await request.patch(
      `/suppliers/custom_interrogators/${customInterrogationId}`,
      keysToSnakeCaseDeep(data),
    );
    return {
      ...customInterrogation,
      taskInputs: keysToSnakeCaseDeep(customInterrogation.taskInputs),
    };
  },

  delete: async (customInterrogationId) => {
    await request.delete(
      `/suppliers/custom_interrogators/${customInterrogationId}`,
    );
  },
};
